module.exports = __webpack_public_path__ + "img/h5img5.18a13c1c.png";